if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            if (productElement) {
              this.preprocessHTML(productElement, responseHTML);
              HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement, responseHTML) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.cleanViewDetailsLinks(productElement);
        this.removeDOMElements(productElement);
        this.preventDuplicatedIDs(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
        if (responseHTML) {
          this.injectModalHeader(productElement, responseHTML);
        }
      }

      injectModalHeader(productElement, responseHTML) {
        if (productElement.querySelector('.quick-add-header-card')) return;

        const mainImg = responseHTML.querySelector('.product__media-wrapper img, .product__image-slider img, img[data-media-id], .carousel-cell img');
        const titleEl = productElement.querySelector('.product__title');

        if (!titleEl) return;

        const headerCard = document.createElement('div');
        headerCard.className = 'quick-add-header-card';
        headerCard.style.cssText = 'display: flex; align-items: center; gap: 14px; padding-bottom: 14px; margin-bottom: 14px; border-bottom: 1.5px solid #E2E8F0; width: 100%; box-sizing: border-box;';

        if (mainImg) {
          const thumbBox = document.createElement('div');
          thumbBox.style.cssText = 'width: 72px; height: 72px; min-width: 72px; min-height: 72px; max-width: 72px; max-height: 72px; border-radius: 12px; border: 1.5px solid #E2E8F0; background: #FFFFFF; display: flex; align-items: center; justify-content: center; padding: 4px; box-sizing: border-box; flex-shrink: 0;';
          
          const imgClone = mainImg.cloneNode(true);
          imgClone.style.cssText = 'width: 100%; height: 100%; object-fit: contain; border-radius: 6px; display: block;';
          thumbBox.appendChild(imgClone);
          headerCard.appendChild(thumbBox);
        }

        const textWrap = document.createElement('div');
        textWrap.style.cssText = 'display: flex; flex-direction: column; gap: 3px; flex: 1; min-width: 0;';
        
        const badge = document.createElement('span');
        badge.style.cssText = 'font-size: 11px; font-weight: 800; color: #0066FF; letter-spacing: 0.05em; text-transform: uppercase; line-height: 1.2;';
        badge.textContent = 'Certified Refurbished & QC Tested';
        textWrap.appendChild(badge);

        const titleHeading = titleEl.querySelector('h1, h2') || titleEl;
        const titleText = titleHeading.textContent.replace(/Certified Refurbished & QC Tested/gi, '').trim();

        const titleClone = document.createElement('h3');
        titleClone.style.cssText = 'font-family: var(--font-heading, "Sora", sans-serif); font-size: 15px; font-weight: 800; color: #0F172A; margin: 0; line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;';
        titleClone.textContent = titleText;
        textWrap.appendChild(titleClone);

        headerCard.appendChild(textWrap);

        productElement.insertBefore(headerCard, productElement.firstChild);
        titleEl.style.display = 'none';
      }

      cleanViewDetailsLinks(productElement) {
        productElement.querySelectorAll('.product__view-details').forEach((link) => {
          const sanitizedLabel = link.textContent.replace(/\uFFFD/g, '').split('<svg')[0].trim();
          link.textContent = sanitizedLabel;
          link.classList.remove('animate-arrow');
        });
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        // Remove unstyled Buy Now / Shopify payment button in Quick Add modal
        const paymentButtons = productElement.querySelectorAll('.shopify-payment-button, shopify-payment-button, [data-shopify="payment-button"], .shopify-payment-button__button');
        paymentButtons.forEach((btn) => btn.remove());

        // Remove Zippy pincode widget & payment badges fluff inside Quick Add modal
        const fluffElements = productElement.querySelectorAll('[class*="zippy" i], [id*="zippy" i], .payment-icons-wrapper, .cash-on-delivery, [class*="payment-icon" i]');
        fluffElements.forEach((el) => el.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
